<template>
  <q-page padding>
    <h3 class="text-gompels-highlight q-mt-sm text-center">Branches</h3>
    
    <div class="row q-gutter-lg justify-center q-mb-md">
			<q-card
					class="col-12 col-sm-6 col-md-3 q-pa-sm flex column justify-between"
					v-for="branch in branches"
					:key="branch.name">
        <q-img
            v-if="branch.image"
            :src="branch.image"
            class="branch-image"
            height="160px"
            fit="contain"
            @click="onDetailsClick(branch)">
          <q-tooltip>
            Click for more details
          </q-tooltip>
        </q-img>
        
        <q-card-section class="q-pb-none">
          <h5 class="text-weight-bold text-center text-gompels-green q-mt-sm branch-name"
              @click="onDetailsClick(branch)">
            {{ branch.name }}
            <q-tooltip>
              Click for more details
            </q-tooltip>
          </h5>
          
          <p v-if="branch.address" class="q-my-xs">
            <q-icon name="fal fa-map-marker-alt" color="gompels-highlight" class="q-mr-sm"/>
            <a
                :href="'https://www.google.com/maps?q=' + encodeURIComponent(branch.address)"
                target="_blank"
                class="text-primary card-link">
              {{ branch.address }}
            </a>
          </p>
          
          <p v-if="branch.phone" class="q-my-xs">
            <q-icon name="fal fa-phone-alt" color="gompels-highlight" class="q-mr-sm"/>
            <a :href="'tel:' + branch.phone" class="text-primary card-link">{{ branch.phoneDisplay }}</a>
          </p>
          
          <p v-if="branch.email" class="q-my-xs">
            <q-icon name="fal fa-envelope-open" color="gompels-highlight" class="q-mr-sm"/>
            <a :href="'mailto:' + branch.email" class="text-primary card-link">{{ branch.email }}</a>
          </p>
        </q-card-section>

        <div class="full-width">
          <q-card-actions align="right">
            <q-btn color="gompels-green" label="View More" flat @click="onDetailsClick(branch)"/>
          </q-card-actions>
        </div>
      </q-card>
    </div>
  </q-page>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useServicesStore } from 'stores/services';

export default defineComponent({
  name: 'ContactPage',
  setup() {
    const $store = useServicesStore();
    const $router = useRouter();
    
    const branches = computed(() => $store.branches);
    
    function onDetailsClick(branch: (typeof branches.value)[number]) {
      $store.setSelectedBranch(branch);
      if (branch.slug === 'homeward-pharmacy') {
        window.open('https://homewardpharmacy.co.uk/contact-details/homeward-pharmacy', '_blank')
      } else {
        $router.push({ name: 'contact-details', params: { slug: branch.slug } });
      }
    }
    
    return {
      branches,
      onDetailsClick,
    };
  },
});
</script>

<style scoped lang="scss">
:deep(.card-link) {
  text-decoration: none;
	font-size: 14px;
}

.branch-image {
  cursor: pointer;
}

.branch-image:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

.branch-name {
  cursor: pointer;
	margin-top: unset;
	margin-bottom: unset;
}

.branch-name:hover {
  color: $gompels-green-light;
}
</style>
